import React from "react";
import {useWeglot} from "./contexts/WeglotContext";
import {Pages} from "./bi-events/enum";
import {useUtils} from "./contexts";
import {FormControl, SelectChangeEvent} from "@mui/material";
import CustomMenuItem from "./components/menus/CustomMenuItem";
import CustomSelect from "./components/inputs/CustomSelect";
import {Colors, IconGlobe} from "./bounce-ui/assets";

const languages = [
  {code: "en", label: "English"},
  {code: "es", label: "Español"},
];

const LanguageSwitcher = () => {
  const {pageClickEvent} = useUtils();
  const {currLanguage, setCurrLanguage} = useWeglot();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedLanguage = event.target.value;
    if (window.Weglot?.switchTo) {
      window.Weglot.switchTo(selectedLanguage);
    }
    setCurrLanguage(selectedLanguage);
    pageClickEvent({
      page: Pages.LANGUAGE_SWITCHER,
      cta: "switch",
      data: {selected: selectedLanguage},
    });
  };

  if (!window.Weglot) return null;

  return (
    <FormControl sx={{marginTop: "20px"}}>
      <CustomSelect
        value={currLanguage}
        onChange={handleChange}
        renderValue={(value) => {
          const selectedLanguage = languages.find((lang) => lang.code === value);
          return (
            <CustomMenuItem
              label={selectedLanguage?.label || ""}
              icon={<IconGlobe width={20} height={20} color={Colors.primary._800} />}
              hasHover={false}
            />
          );
        }}
      >
        {languages.map((language) => (
          <CustomMenuItem
            key={language.label}
            label={language.label}
            value={language.code}
            disabled={language.code === currLanguage}
          />
        ))}
      </CustomSelect>
    </FormControl>
  );
};

export default LanguageSwitcher;
